// src/pages/PrivacyPolicy.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseLayout from '../components/BaseLayout';

export default function PrivacyPolicy() {
  const { t } = useTranslation('legal');

  return (
    <BaseLayout>
      <div className="p-6 max-w-3xl mx-auto bg-black/60 backdrop-blur-md rounded-lg text-white">
        <h1 className="text-3xl font-bold mb-4">{t('privacy.title')}</h1>
        <p className="mb-2">
          {t('privacy.intro')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('privacy.informationCollect.title')}</h2>
        <ul className="list-disc list-inside mb-4">
          <li>{t('privacy.informationCollect.items.googleAccount')}</li>
          <li>{t('privacy.informationCollect.items.channelData')}</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('privacy.howWeUse.title')}</h2>
        <ul className="list-disc list-inside mb-4">
          <li>{t('privacy.howWeUse.items.authenticate')}</li>
          <li>{t('privacy.howWeUse.items.fetchData')}</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('privacy.dataSharing.title')}</h2>
        <p className="mb-4">
          {t('privacy.dataSharing.content')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('privacy.contact.title')}</h2>
        <p>{t('privacy.contact.content')}</p>
      </div>
    </BaseLayout>
  );
}
